export default __webpack_public_path__ + "static/media/button_upload_ja.4fc0c397.svg";